export default __webpack_public_path__ + "static/media/IconDesc_Quickwire.256.0cbf172e.png";